import { Injectable } from "@angular/core";
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UnitOfMeasure, SiteInformation, Commodity, ProductExperience, MenuOption } from '../models/site.model';
import { AppSettings } from "../../app.settings";

@Injectable()
export class SiteService extends BaseService {
    constructor(private http: HttpClient, private config: AppSettings) {
        super();
    }

    getUnitOfMeasure(): Observable<UnitOfMeasure[]> {
        const url = `${this.config.BaseUrl}Profile/UnitOfMeasure`;
        return this.http.get<UnitOfMeasure[]>(url, { headers: this.setHeaders() });
    }

    getSiteInformation(supplierCode: string, siteId: number): Observable<SiteInformation> {
        const url = `${this.config.BaseUrl}Profile/${supplierCode}/Site/${siteId}/Information`;
        return this.http.get<SiteInformation>(url, { headers: this.setHeaders() });
    }

    postSiteInformation(supplierCode: string, siteId: number, model: SiteInformation): Observable<SiteInformation> {
        const url = `${this.config.BaseUrl}Profile/${supplierCode}/Site/${siteId}/Information`;
        return this.http.post<SiteInformation>(url, model, { headers: this.setHeaders() });
    }

    putSiteInformation(supplierCode: string, siteId: number, id: number, model: SiteInformation): Observable<SiteInformation> {
        const url = `${this.config.BaseUrl}Profile/${supplierCode}/Site/${siteId}/Information/${id}`;
        return this.http.put<SiteInformation>(url, model, { headers: this.setHeaders() });
    }

    getCommodities(): Observable<Commodity[]> {
        const url = `${this.config.BaseUrl}Profile/ProductExperience/Commodities`;
        return this.http.get<Commodity[]>(url, { headers: this.setHeaders() });
    }

    getProductExperiences(supplierCode: string, siteId: number): Observable<ProductExperience[]> {
        const url = `${this.config.BaseUrl}Profile/${supplierCode}/Site/${siteId}/ProductExperience`;
        return this.http.get<ProductExperience[]>(url, { headers: this.setHeaders() });
    }

    postProductExperience(supplierCode: string, siteId: number, model: ProductExperience): Observable<ProductExperience> {
        const url = `${this.config.BaseUrl}Profile/${supplierCode}/Site/${siteId}/ProductExperience`;
        return this.http.post<ProductExperience>(url, model, { headers: this.setHeaders() });
    }

    putProductExperience(supplierCode: string, siteId: number, id: number, model: ProductExperience): Observable<ProductExperience> {
        const url = `${this.config.BaseUrl}Profile/${supplierCode}/Site/${siteId}/ProductExperience/${id}`;
        return this.http.put<ProductExperience>(url, model, { headers: this.setHeaders() });
    }

    deleteProductExperience(supplierCode: string, siteId: number, id: number): Observable<any> {
        const url = `${this.config.BaseUrl}Profile/${supplierCode}/Site/${siteId}/ProductExperience/${id}`;
        return this.http.delete(url, { headers: this.setFileHeaders() });
    }

    getMaterialClases(): Observable<MenuOption[]> {
        const url = `${this.config.BaseUrl}Profile/ProductExperience/MaterialClass`;
        return this.http.get<MenuOption[]>(url, { headers: this.setHeaders() });
    }

    getMaterialGrades(materialClassId: number): Observable<MenuOption[]> {
        const url = `${this.config.BaseUrl}Profile/ProductExperience/MaterialClass/${materialClassId}/MaterialGrade`;
        return this.http.get<MenuOption[]>(url, { headers: this.setHeaders() });
    }
}
